module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Доступные объекты","amount":"кол-во","signs":"Знаки","events":"События"},"en":{"title":"Available objects","amount":"amount","signs":"Signs","events":"Events"}}')
  delete Component.options._Ctor
}
